// extracted by mini-css-extract-plugin
export default {"baseModalWrapper":"BaseModal_baseModalWrapper__tb44C","MuiOutlinedInput-root":"BaseModal_MuiOutlinedInput-root__aOKVR","MuiInputLabel-root":"BaseModal_MuiInputLabel-root__DrPri"};